import { lineHeight, padding } from "@mui/system";
import { color } from "highcharts";

export const commonCss = {
  quickTextUl: {
    paddingTop: 0,
    paddingBottom: 0,
    color: "gray",
    fontSize: "14px",
    paddingLeft: "0px",
  },
  routerLinkText: {
    display: "flex",
    color: "gray",
    textDecoration: "none",
    padding: "0px 0px 0px 8px",
    "&:hover": {
      color: "#007BFF",
      textDecoration: "underline",
    },
  },
};

export const radioLabel = {
  label: {
    ".MuiTypography-root": {
      fontSize: "13px", // Ensure this targets the inner Typography
      lineHeight: "16px",
    },
    color: "#5d586c",
    fontWeight: 400,
    textAlign: "left",
    textUnderlinePosition: "from-font",
    textDecorationSkipInk: "none",
  },

  additionLabel: {
    // ".MuiTypography-root": {
    fontSize: "13px", // Ensure this targets the inner Typography
    lineHeight: "16px",
    // },
    color: "#5d586c",
    fontWeight: 400,
    textAlign: "left",
    textUnderlinePosition: "from-font",
    textDecorationSkipInk: "none",
  },

  labelDark: {
    // ".MuiTypography-root": {
    fontSize: "14px", // Ensure this targets the inner Typography
    lineHeight: "14px",
    fontWeight: 700,
    // },
    color: "#6f6b7d",
    textAlign: "left",
    textUnderlinePosition: "from-font",
    textDecorationSkipInk: "none",
  },
  labelDarkMobile: {
    fontSize: "12px", // Ensure this targets the inner Typography
    lineHeight: "14px",
    fontWeight: 700,
    color: "#6f6b7d",
    textAlign: "left",
    textUnderlinePosition: "from-font",
    textDecorationSkipInk: "none",
  },
};
